let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bz1s9")).then(() => parcelRequire('jGfPl'));